module.exports = __webpack_public_path__ + "img/product3.6b6133c6.png";